//? -> https://riesenia.atlassian.net/browse/DUB-169?focusedCommentId=92899

var rEvent = {
  queue: {},
  dispatch: function(eventName, ...data) {
    var event = this.queue[eventName],
    once = false;


    if (typeof event === 'undefined') {
      return;
    }

    if (typeof data === 'undefined') {
      data = {};
    }

    if (once) {
        while (event.callbacks.length) {
          (event.callbacks.shift())(...data);
        }
    } else {
        for (var i = 0; i < event.callbacks.length; i++) {
          (event.callbacks[i])(...data);
        }
    }

    this.queue[eventName].fired = true;
    this.queue[eventName].data = data;
  },
  on: function(eventName, callback) {
    // event was already fired
    // if (typeof this.queue[eventName] !== 'undefined' && event.fired) {
      // return callback();
    // }

    if (typeof this.queue[eventName] === 'undefined') {
      this.queue[eventName] = {
        fired: false,
        callbacks: []
      };
    }

    this.queue[eventName].callbacks.push(callback);
  }
};